import { activateActionTypes } from '../actions/activate-action-types';

const initialState = {
    statusRequestState: null,
    statusRequestErrorMessage: null,
    activateEmailState: null,
    activateEmailErrorMessage: null,
    activationDate: null,
    activationEmail: null,
    activationFirstName: null,
    albumId: null
};

export const activateLandingPage = (state = initialState, action) => {

    switch (action.type) {

        case activateActionTypes.GET_ACTIVATE_STATUS_REQUEST:

            console.log(activateActionTypes.GET_ACTIVATE_STATUS_REQUEST);

            return {
                ...state,
                statusRequestState: "requested",
                statusRequestErrorMessage: null
            };

        case activateActionTypes.GET_ACTIVATE_STATUS_SUCCESS:
            if(action.result.errorMessage){
                return {
                    ...state,
                    statusRequestState: "failed",
                    statusRequestErrorMessage: action.result.errorMessage
                };
            } else {
                return {
                    ...state,
                    statusRequestState: "success",
                    statusRequestErrorMessage: null,
                    activationDate: action.result.activationDate,
                    activationEmail: action.result.email,
                    activationFirstName: action.result.firstName,
                    albumId: action.result.rootCustomCollectionId
                };
            }

        case activateActionTypes.GET_ACTIVATE_STATUS_FAILED:
            return {
                ...state,
                statusRequestState: "failed",
                statusRequestErrorMessage: action.error.message
            };

        case activateActionTypes.GET_ACTIVATE_STATUS_404:

            console.log(activateActionTypes.GET_ACTIVATE_STATUS_404);

            return {
                ...state,
                statusRequestState: "missing",
                statusRequestErrorMessage: null
            };

        case activateActionTypes.SEND_ACTIVATION_EMAIL_REQUEST:

            console.log(activateActionTypes.SEND_ACTIVATION_EMAIL_REQUEST);

            return {
                ...state,
                activateEmailState: "requested",
                activateEmailErrorMessage: null
            };

        case activateActionTypes.SEND_ACTIVATION_EMAIL_SUCCESS:

            console.log(activateActionTypes.SEND_ACTIVATION_EMAIL_SUCCESS);

            return {
                ...state,
                activateEmailState: "success",
                activateEmailErrorMessage: null
            };

        case activateActionTypes.SEND_ACTIVATION_EMAIL_FAILED:

            console.log(activateActionTypes.SEND_ACTIVATION_EMAIL_FAILED);

            return {
                ...state,
                activateEmailState: "failed",
                activateEmailErrorMessage: "Error sending activation email."
            };

        default:
            return state


    }

};


// WEBPACK FOOTER //
// ./src/activate/reducers/activate-landing-page-reducer.js